import styled from "styled-components";

export const Wrapper = styled.div`
  padding-left: 7%;
  padding-right: 5%;
  margin: 0 auto;
  background-color: #fcf9ff;
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  padding-top: 10px;
  padding-bottom: 10px;
  margin: 20px 20px 0 20px;
  border-left: solid 1px red;
  border-right: solid 1px red;
`;
